import React, { useEffect, useState } from "react";
import fetchData from "../../../api/fetchApi";
import { useParams, useNavigate } from "react-router-dom";
import PageHeader from "../../common/PageHeader";

export default function EditResellerPage() {
  const { id } = useParams();
  const [form, setForm] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    setError(null);
    fetchData(`finance/resellers/${id}`)
      .then(data => setForm(data.data))
      .catch(err => setError(err.message || "حدث خطأ أثناء جلب البيانات"))
      .finally(() => setLoading(false));
  }, [id]);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);
    try {
      await fetchData(`finance/resellers/${id}`, "PUT", form);
      setSuccess("تم تحديث بيانات الموزع بنجاح");
      setTimeout(() => navigate(`/finance/resellers/${id}`), 1200);
    } catch (err) {
      setError(err.message || "حدث خطأ أثناء التحديث");
    } finally {
      setLoading(false);
    }
  };

  if (!form) return <div className="text-center mt-8">جاري التحميل...</div>;

  return (
    <div className="min-h-screen p-4 md:p-6 bg-white" dir="rtl">
      <PageHeader title="تعديل بيانات الموزع" total={0} stats={[]} />
      <form onSubmit={handleSubmit} className="max-w-lg mx-auto bg-gray-50 rounded-xl p-6 shadow mt-6 flex flex-col gap-4">
        <input name="name" value={form.name || ""} onChange={handleChange} className="border rounded px-3 py-2" placeholder="اسم الموزع" required />
        <input name="email" value={form.email || ""} onChange={handleChange} className="border rounded px-3 py-2" placeholder="البريد الإلكتروني" required type="email" />
        <input name="address" value={form.address || ""} onChange={handleChange} className="border rounded px-3 py-2" placeholder="العنوان" />
        <input name="phone" value={form.phone || ""} onChange={handleChange} className="border rounded px-3 py-2" placeholder="الهاتف" />
        <input name="admin_email" value={form.admin_email || ""} onChange={handleChange} className="border rounded px-3 py-2" placeholder="البريد الإلكتروني للمسؤول" required type="email" />
        <input name="admin_password" value={form.admin_password || ""} onChange={handleChange} className="border rounded px-3 py-2" placeholder="كلمة مرور المسؤول" required type="password" />
        {error && <div className="text-red-600 text-sm">{error}</div>}
        {success && <div className="text-green-600 text-sm">{success}</div>}
        <div className="flex gap-2 justify-end">
          <button type="submit" className="bg-yellow-500 text-white px-4 py-2 rounded" disabled={loading}>{loading ? "جاري التحديث..." : "تحديث"}</button>
          <button type="button" className="bg-gray-200 px-4 py-2 rounded" onClick={() => navigate(-1)}>إلغاء</button>
        </div>
      </form>
    </div>
  );
}
